import React from 'react';

import Layout, { LayoutProps } from '../Layout';

export const ChannelsPageLayout: React.FC<LayoutProps> = ({
  children,
  ...others
}) => {
  return (
    <Layout disableGutters hasNavbar={false} {...others}>
      {children}
    </Layout>
  );
};
